import { render, staticRenderFns } from "./CalculatorSettings.vue?vue&type=template&id=33fc296e&"
import script from "./CalculatorSettings.vue?vue&type=script&lang=js&"
export * from "./CalculatorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports